import * as yup from "yup";

export const ALLOWED_ANONYMOUS_ROLES = [
  "Juniper Square Investor Services",
  "Juniper Square Investor Services Manager",
];

export const workspaceAssignmentErrorMessages = {
  roleGroupName: "Role is required",
  accessType: "Access type is required",
  anonymousAccessRole: "Anonymous access is only available for Investor Services roles",
  expirationDate: "Expiry date cannot be in the past",
};

export const createAccessTypeValidation = () =>
  yup
    .string()
    .required(workspaceAssignmentErrorMessages.accessType)
    .test(
      "anonymous-access-role",
      workspaceAssignmentErrorMessages.anonymousAccessRole,
      function (value) {
        if (value !== "unnamed") return true;
        const roleGroupName = this.parent.roleGroupName;
        return ALLOWED_ANONYMOUS_ROLES.includes(roleGroupName);
      },
    );

export const createExpirationDateValidation = () =>
  yup
    .date()
    .nullable()
    .test("expiry-date", workspaceAssignmentErrorMessages.expirationDate, (value) => {
      if (!value) return true;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(value);
      target.setHours(0, 0, 0, 0);
      return target > today;
    });
